import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { serverValidators } from '../utils/validators';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATION_ITEM } from '../../../../../../../webcomponents.constants';
import { GzCheckboxWebComponent } from '../../../../../../../ui/gzCheckbox';

@customElement(WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATION_ITEM)
export class GzRelayUpdateLocationItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#locationItemServer')
  locationItemServer: GzFormFieldWebComponent<GzInputWebComponent, string>;

  @query('#locationItemUseProxy')
  locationItemUseProxy: GzFormFieldWebComponent<GzCheckboxWebComponent>;

  /**
   * Fields from the current component are connected. When an external error is set,
   * any change on another field should remove external validation from server.
   */
  private shouldBeRevalidatedOnFieldChange = false;

  public setError(error: string) {
    this.shouldBeRevalidatedOnFieldChange = true;
    this.locationItemServer.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field input--w70">
        <gz-form-field id="locationItemServer">
          <gz-input
            gz-form-input
            label="${translateFn('Add location')}"
            placeholder="${translateFn('Server')}"
          ></gz-input>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field">
        <gz-form-field id="locationItemUseProxy">
          <gz-checkbox
            style="top: 5px"
            gz-form-input
            label="${translateFn('Use proxy')}"
            @change="${e => {
              if (this.shouldBeRevalidatedOnFieldChange) {
                this.shouldBeRevalidatedOnFieldChange = false;
                this.locationItemServer.validate(true);
              }
            }}"
          ></gz-checkbox>
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.locationItemServer.Input.inputFocus();
  }

  createFormGroup(): void {
    this.locationItemServer.Validators = serverValidators();

    this.formGroup = new FormGroup({
      server: this.locationItemServer,
      useProxy: this.locationItemUseProxy,
    });
  }

  resetForm(): void {
    this.locationItemUseProxy.value = false;
    this.locationItemUseProxy.resetField();

    this.locationItemServer.value = '';
    this.locationItemServer.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm();
  }
}
